import {Link} from "react-router";
import { getRole } from "./common/user-role";

function Navbar() {
  return (
    <div className="bg-black/50 w-full">
      <ul className="px-4">
        <li className="inline-block py-1 px-3 hover:bg-slate-800">
          <Link to="/">Retreats</Link>
        </li>
        {getRole() === "admin" && (
          <li className="inline-block py-1 px-3 hover:bg-slate-800">
            <Link to="/sales">Sales</Link>
          </li>
        )}
        <li className="inline-block py-1 px-3 hover:bg-slate-800">
            <Link to="/search">Search</Link>
        </li>
      </ul>
    </div>
  )
}

export default Navbar;